// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__11MZx","label":"Radio_label__2klSl","checkMark":"Radio_checkMark__1SkE3","disabled":"Radio_disabled__3wku6"};